import { render, staticRenderFns } from "./create-email-form.vue?vue&type=template&id=507bf26c"
import script from "./create-email-form.vue?vue&type=script&lang=js"
export * from "./create-email-form.vue?vue&type=script&lang=js"
import style0 from "./create-email-form.vue?vue&type=style&index=0&id=507bf26c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports